import { Stack, styled } from "@mui/material";
import { HeadingM } from "../Typography";

export const ImageContainer = styled(Stack)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    height: "100%",
    aspectRatio: "1/1",
    flexShrink: 0,
    marginRight: theme.spacing(3),
}));

export const IconCardTop = styled(Stack)(() => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
}));

export const IconCardTopLeft = styled(Stack)(() => ({
    width: "80%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
}));

export const IconCardBottom = styled(Stack)(() => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
}));

export const IconCardContent = styled(Stack)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    padding: theme.spacing(3),
}));

export const IconCardTitle = styled(HeadingM)(() => ({
    marginBottom: 0,
}));
